import React, { forwardRef } from 'react';
import BaseButton, { BaseButtonProps } from './BaseButton';

interface IconTextButtonProps extends BaseButtonProps {
  icon?: string;
  iconAlt?: string;
  children?: React.ReactNode;
}

const IconTextButton = forwardRef<HTMLButtonElement, IconTextButtonProps>(({
  icon,
  iconAlt = 'Icon',
  children,
  ...props
}, ref) => {
  // Add console log for debugging button clicks
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    console.log(`IconTextButton clicked: ${props.onClick ? 'has onClick handler' : 'no onClick handler'}`);
    if (props.onClick) {
      props.onClick(e);
    }
  };
  
  return (
    <BaseButton 
      {...props}
      onClick={handleClick} // Use our debug handler
      ref={ref}
      className={`icon-text-button ${props.className || ''}`}
    >
      {icon && (
        <img 
          src={icon} 
          alt={iconAlt} 
          className="button-icon"
        />
      )}
      {children}
    </BaseButton>
  );
});

IconTextButton.displayName = 'IconTextButton';

export default IconTextButton; 